import BlogHeader from "../components/BlogHeader";

const Section = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-display font-bold text-xl tracking-tight">{title}</h2>
    <div className="mt-4 space-y-3 text-sm text-neutral-600 leading-relaxed">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <div className="bg-[#FAF8F5] min-h-screen">
      <BlogHeader />
      <main data-testid="privacy-page" className="max-w-3xl mx-auto px-5 sm:px-8 py-14">
        <p className="mono-label text-[#E05638]">Documento legale</p>
        <h1 className="font-display font-bold tracking-tight text-3xl sm:text-4xl mt-4">
          Privacy Policy e Cookie
        </h1>
        <p className="text-xs text-neutral-400 mt-3">Ultimo aggiornamento: settembre 2026</p>

        <Section title="1. Titolare del trattamento">
          <p>
            Il titolare del trattamento dei dati è <strong>Lumora</strong>, studio web con sede
            operativa a Novara (Italia), contattabile all'indirizzo email{" "}
            <a href="mailto:lumoratech.it@gmail.com" className="text-[#E05638] hover:underline">
              lumoratech.it@gmail.com
            </a>
            .
          </p>
        </Section>

        <Section title="2. Quali dati raccogliamo">
          <p>A seconda di come usi il sito, raccogliamo:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong>Moduli di contatto e agevolazioni:</strong> nome, email, nome dell'attività e
              il messaggio che ci scrivi.
            </li>
            <li>
              <strong>Area clienti:</strong> nome, email e password (conservata in forma protetta,
              mai in chiaro).
            </li>
            <li>
              <strong>Pagamenti:</strong> gestiti interamente da Stripe e PayPal. Non vediamo né
              conserviamo i dati della tua carta.
            </li>
            <li>
              <strong>Chat di assistenza:</strong> i messaggi che scrivi all'assistente, usati per
              risponderti e migliorare il servizio.
            </li>
            <li>
              <strong>Statistiche di visita anonime</strong> (solo con il tuo consenso): pagina
              visitata e sito di provenienza, senza identificarti personalmente.
            </li>
          </ul>
        </Section>

        <Section title="3. Perché li usiamo">
          <ul className="list-disc pl-5 space-y-2">
            <li>Rispondere alle tue richieste e preparare preventivi (misura precontrattuale).</li>
            <li>Creare e gestire il tuo account, il tuo sito e i pagamenti (esecuzione del contratto).</li>
            <li>Migliorare il sito tramite statistiche anonime (solo con il tuo consenso).</li>
            <li>Sicurezza e prevenzione degli abusi (legittimo interesse).</li>
          </ul>
        </Section>

        <Section title="4. Per quanto tempo li conserviamo">
          <p>
            I dati del tuo account restano finché il rapporto è attivo e per il tempo richiesto da
            obblighi di legge. Le richieste di contatto o agevolazione non evase vengono conservate
            al massimo 24 mesi. Puoi chiedere la cancellazione in qualsiasi momento.
          </p>
        </Section>

        <Section title="5. Chi può vedere i tuoi dati">
          <p>
            Ci appoggiamo a pochi fornitori essenziali, che trattano i dati secondo le proprie
            informative: Stripe e PayPal (pagamenti), Google (accesso con account Google e Search
            Console), un servizio di email transazionale (per le nostre comunicazioni) e il provider
            di hosting cloud dove risiede il sito. Non vendiamo né cediamo i tuoi dati a nessuno.
          </p>
        </Section>

        <Section title="6. Cookie e archiviazione locale">
          <p>Questo sito usa esclusivamente:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong>Cookie tecnici</strong>, indispensabili: sessione di accesso all'area clienti
              e la tua scelta sul consenso.
            </li>
            <li>
              <strong>Statistiche anonime</strong>, attivate solo se premi "Accetta" nel banner: un
              identificativo casuale di visita, che non ci permette di sapere chi sei.
            </li>
          </ul>
          <p>
            Nessun cookie pubblicitario o di profilazione. Puoi cambiare idea in qualsiasi momento
            cancellando i dati del sito dal tuo browser: il banner ti riapparirà.
          </p>
        </Section>

        <Section title="7. I tuoi diritti">
          <p>
            In qualsiasi momento puoi chiederci accesso, rettifica, cancellazione dei tuoi dati o
            opporti al loro uso scrivendo a{" "}
            <a href="mailto:lumoratech.it@gmail.com" className="text-[#E05638] hover:underline">
              lumoratech.it@gmail.com
            </a>
            . Hai inoltre diritto di reclamo al Garante per la protezione dei dati personali
            (www.garanteprivacy.it).
          </p>
        </Section>

        <Section title="8. Modifiche a questa pagina">
          <p>
            Se aggiorneremo questa informativa, la nuova versione sarà pubblicata qui con la data di
            revisione aggiornata.
          </p>
        </Section>
      </main>
    </div>
  );
}
